import React, { useMemo, useCallback } from 'react';
import EpiContext from "@episerver/spa-core/Spa";

const UsageBar = React.memo(({
                                 usedQuantity: initialUsedQuantity,
                                 maxUsageQuantity,
                                 usedUnitOfMeasure,
                                 quantityUnitOfMeasure,
                                 cycleRemainingDays,
                                 extraLinkText,
                                 extraLinkLink,
                                 moreInfoText,
                                 moreInfoLink
                             }) => {
    const usedQuantity = useMemo(() => {
        return usedUnitOfMeasure === 'MB' && quantityUnitOfMeasure === 'GB'
            ? (initialUsedQuantity / 1024).toFixed(2)
            : initialUsedQuantity;
    }, [initialUsedQuantity, usedUnitOfMeasure, quantityUnitOfMeasure]);

    const percent = useMemo(() => Math.floor((usedQuantity / maxUsageQuantity) * 100), [usedQuantity, maxUsageQuantity]);

    const getColorByPercent = useCallback((percent) => {
        if (percent <= 25) return 'light-purple';
        if (percent <= 50) return 'purple';
        if (percent <= 75) return 'dark-purple';
        return 'red';
    }, []);

    const colorClass = getColorByPercent(percent);

    const handleNavigate = useCallback((link) => {
        EpiContext.navigateTo(link);
    }, []);

    return (
        <div className='usage_details'>
            <div className='usage_item'>
                <div className='usage-text'>
                    <span className={`usage_quantity ${usedQuantity > maxUsageQuantity ? 'red' : ''}`}>
                        <span>{quantityUnitOfMeasure}</span>
                        <span className='usage'>
                            <span className={`usage-amount ${colorClass}`}>{usedQuantity}</span>
                            /<span className='max-amount'>{maxUsageQuantity}</span>
                        </span>
                    </span>
                    <div className='cycleDate'>
                        <span> נותרו <span className='bold'>{cycleRemainingDays} ימים</span> עד סוף מחזור החיוב</span>
                    </div>
                </div>
                <div className={`UsageBar ${colorClass}`}>
                    <div className={`percent ${colorClass}`} style={{ width: `${percent}%` }}></div>
                </div>
            </div>
            {percent >= 75 && (
                <div className='exceeded-limit-link-container red'>
                    <span onClick={() => handleNavigate(extraLinkLink)}>{extraLinkText}</span>
                    <span onClick={() => handleNavigate(moreInfoLink)}>{moreInfoText}</span>
                </div>
            )}
        </div>
    );
});

export default UsageBar;
